export const LEGACY_COMMENTS_PAGE_SIZE = 200;
export const COMMENTS_PAGE_SIZE = 10;
export const INITIAL_REPLIES_TO_SHOW = 2;
